// extracted by mini-css-extract-plugin
module.exports = {"redlLayoutWrapper":"LayoutWrapper_redlLayoutWrapper__IwmK6"};